/**
 * LocalOrder entity - maps to local_orders table.
 */

import type { EntitySchema } from '../types';

export interface LocalOrder {
  id: string;
  company_id: string;
  agent_code: string;
  customer_id: string | null;
  customer_code: string;
  customer_name: string;
  delivery_date: string;
  delivery_time: string | null;
  state: string;
  notes: string | null;
  draft_code: string | null;
  sync_error: string | null;
  source_device_id: string | null;
  server_id: string | null;
  created_at: string;
  updated_at: string;
}

export const LocalOrderSchema: EntitySchema<LocalOrder> = {
  tableName: 'local_orders',
  columns: [
    { name: 'id', type: 'TEXT', primary: true },
    { name: 'company_id', type: 'TEXT', nullable: false },
    { name: 'agent_code', type: 'TEXT', nullable: false },
    { name: 'customer_id', type: 'TEXT', nullable: true },
    { name: 'customer_code', type: 'TEXT', nullable: false },
    { name: 'customer_name', type: 'TEXT', nullable: false },
    { name: 'delivery_date', type: 'TEXT', nullable: false },
    { name: 'delivery_time', type: 'TEXT', nullable: true },
    { name: 'state', type: 'TEXT', nullable: false, default: 'draft' },
    { name: 'notes', type: 'TEXT', nullable: true },
    { name: 'draft_code', type: 'TEXT', nullable: true },
    { name: 'sync_error', type: 'TEXT', nullable: true },
    { name: 'source_device_id', type: 'TEXT', nullable: true },
    { name: 'server_id', type: 'TEXT', nullable: true },
    { name: 'created_at', type: 'TEXT', nullable: false },
    { name: 'updated_at', type: 'TEXT', nullable: false },
  ],
  indexes: [
    { name: 'idx_local_orders_company_id', columns: ['company_id'] },
    { name: 'idx_local_orders_delivery_date', columns: ['delivery_date'] },
    { name: 'idx_local_orders_state', columns: ['state'] },
  ],
};
